<template>
  <div
    class="tw-flex tw-border tw-border-t-2 tw-border-border tw-bg-background tw-p-4 tw-items-start tw-text-text"
    :class="borderLeftColor"
    role="alert"
  >
    <font-awesome-icon
      :icon="`fa-regular ${icon}`"
      class="tw-text-base tw-mr-3"
      :class="iconClass"
    />
    <span class="tw-flex-1 nx-text-body2">
      <slot>
        <span>{{ message }}</span>
      </slot>
    </span>
    <Btn
      variant="link"
      class="p-0"
      data-dismiss="alert"
      aria-label="Close"
      v-if="dismissible"
      @click="close"
    >
      <font-awesome-icon icon="fa-solid fa-xmark" class="tw-text-icon tw-text-base" />
    </Btn>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import { computed } from "vue";

export default {
  name: "Alert",
  components: {
    Btn,
  },
  props: {
    variant: {
      type: String,
      default: "info",
    },
    message: String,
    id: [Number, String],
    dismissible: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const BORDER_LEFT_COLOR_MAP = {
      success: "tw-border-t-success-border",
      danger: "tw-border-t-danger-border",
      warning: "tw-border-t-warning-border",
      info: "tw-border-t-highlight-border",
    };
    const ICON_CLASS = {
      success: "tw-text-success-icon",
      danger: "tw-text-danger-icon",
      warning: "tw-text-warning-icon",
      info: "tw-text-highlight-icon",
    };
    const ICON_MAP = {
      success: "fa-circle-check",
      danger: "fa-circle-xmark",
      warning: "fa-triangle-exclamation",
      info: "fa-circle-info",
    };

    const borderLeftColor = computed(
      () => BORDER_LEFT_COLOR_MAP[props.variant] || BORDER_LEFT_COLOR_MAP.info
    );

    const close = () => emit("close", { message: props.message, id: props.id });

    const icon = computed(() => ICON_MAP[props.variant] || ICON_MAP.info);
    const iconClass = computed(() => ICON_CLASS[props.variant] || ICON_CLASS.info);

    return {
      borderLeftColor,
      close,
      icon,
      iconClass,
    };
  },
};
</script>
